var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDiagramGroup, } from '../helpers';
import { buildSchematic, createSymbol } from '../symbols';
import { listSchematicSymbols } from '../schematicIcons';
/** Create electrical schematic */
export function createSchematic(app, components, options) {
    if (options === void 0) { options = {}; }
    var group = buildSchematic(app, components);
    group.metadata = __assign(__assign({}, group.metadata), { diagramType: 'electricalSchematic', diagramState: __assign(__assign({}, options), { components: components }) });
    return group;
}
/** Grid catalog of IEC electronic schematic symbols (optional category filter). */
export function createSchematicSymbolCatalog(app, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var category = options.category;
    var kinds = listSchematicSymbols(category);
    var columns = Math.max(4, (_a = options.columns) !== null && _a !== void 0 ? _a : 8);
    var group = createDiagramGroup(app, 'schematicSymbolCatalog', __assign(__assign({}, options), { category: category }), { name: 'schematicCatalog' });
    var gapX = 120;
    var gapY = 102;
    var startX = 16;
    var startY = 12;
    kinds.forEach(function (meta, i) {
        var col = i % columns;
        var row = Math.floor(i / columns);
        var node = createSymbol(app, meta.kind, startX + col * gapX, startY + row * gapY, meta.label);
        node.metadata = __assign(__assign({}, node.metadata), { diagramId: meta.kind });
        group.add(node);
    });
    return group;
}
